import React, { useState, useEffect } from "react";
import "./Loader.css"; // Create this CSS file for styling

const images = ["/schoolBag-min.jpg", "/pant-min.jpg", "/shoe-min.jpg"]; // Replace with your image URLs
function multiColor() {
  const randomColorNumber = () => Math.floor(Math.random() * 255) + 1;
  //console.log(randomColorNumber());
  const color = `rgb(${randomColorNumber()},${randomColorNumber()} , ${randomColorNumber()})`;
  return color;
}

const Loader = () => {
  const [showImage, setShowImage] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowImage(false);
    }, 1500); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const handleImageTransitionEnd = () => {
    setShowImage(!showImage);
    setCurrentImageIndex((prevIndex) => {
      return (prevIndex + 1) % images.length;
    });
  };
 

  return (
    <div className="main-body">
      <div className="animation-container">
        <img
          className={`fade-image ${showImage ? "visible" : "hidden"}`}
          src={images[currentImageIndex]}
          alt="Animated-pics"
          onTransitionEnd={handleImageTransitionEnd}
        />
        <div className="circles-container">
          {Array.from({ length: 6 }, (_, i) => (
            <div
              className="circle"
              style={{ backgroundColor: multiColor(), animationDelay: `${i}s`,transition:' background-color 1s ease-in-out' }}
              key={i}
            ></div>
          ))}

        
          {/* Add more circles with different colors as needed */}
        </div>
      </div>
    </div>
  );
};

export default Loader;
